export class MapFilter {
    public readonly area: number;
    public readonly zipCode: string;
    public readonly limit: number;
    public readonly offset: number;
    public orderByPriceInMon: MonOrderType;
    public returnOnlyBuildingsByMon: boolean;

    public constructor(
        area: number,
        zipCode?: string,
        limit: number = 12,
        offset: number = 0,
        returnOnlyBuildingsByMon: boolean = false,
        orderByPriceInMon: MonOrderType = null
    ) {
        this.area = area;
        this.zipCode = zipCode;
        this.limit = limit;
        this.offset = offset;
        this.orderByPriceInMon = orderByPriceInMon;
        this.returnOnlyBuildingsByMon = returnOnlyBuildingsByMon;
    }
}

export type MonOrderType = "ASC" | "DESC";
